import { onceEach } from "jose_modern/once.js";

export const setupCollapsibleRows = (container) => {
  onceEach(container.querySelectorAll("table [data-expand-row]"), "expand-row", (link) => {
    const tr = link.tagName === "TR" ? link : link.closest("tr");
    if (!tr.classList.contains("is-collapsed") && !tr.classList.contains("is-expanded")) {
      tr.classList.add("is-collapsed");
    }

    link.addEventListener("click", (event) => {
      tr.classList.toggle("is-expanded");
      tr.classList.toggle("is-collapsed");
      event.preventDefault();
      event.stopPropagation();
    });
  });
};

export const initCollapsibleTables = (document) => {
  setupCollapsibleRows(document);
  document.addEventListener("partial:replace", (ev) => setupCollapsibleRows(ev.container));
};
